import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button, Table, Modal, Form, Spinner, Alert, Image } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { fetchCodePostalById, fetchCodePostalsAll } from '../../actions/request/CodePostalRequest';
import { fetchVehicleById, fetchVehiclesAllResearchAvailable } from '../../actions/request/VehicleRequest';
import { Vector_Design, currentDate, emptyImage, logoApplication } from '../../utils/dataApi/dataFormApi';
import { MdAirplaneTicket, MdCategory, MdColorize, MdDateRange, MdMap, MdMarkAsUnread, MdMergeType, MdModelTraining, MdOutlineAirlineSeatReclineNormal, MdOutlineAirplanemodeActive, MdOutlineLocationOn, MdOutlineMoneyOff, MdOutlineTimer, MdPerson, MdTimer, MdToday } from 'react-icons/md';
import { ReservationCreateClient, ReservationCreateClientSimple } from '../../actions/request/ReservationRequest';
import { toast } from 'react-toastify';
import { fetchPropertyById, fetchPropertysAllResearchAvailable } from '../../actions/request/PropertyRequest';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { fetchCompanyAiportsAll } from '../../actions/request/CompanyAiportRequest';
import { Elements, useStripe, useElements, CardNumberElement, CardExpiryElement, CardCvcElement } from '@stripe/react-stripe-js';
import axios from 'axios';
import { baseurl } from '../../utils/url/baseurl';
import { loadStripe } from '@stripe/stripe-js';
import { fetchExchangeRateGetCurency } from '../../actions/request/ExchangeRateRequest';
import { getAndCheckLocalStorage } from '../../utils/storage/localvalueFuction';
import { localStorageData } from '../../utils/storage/localvalue';
import { FETCH_PROPERTY_SUCCESS, FETCH_RESERVATIONS_SUCCESS, FETCH_RESERVATION_FAILURE, FETCH_RESERVATION_REQUEST, FETCH_RESERVATION_SUCCESS, FETCH_VEHICLE_SUCCESS } from '../../app/actions/actions';
import CryptoJS from 'crypto-js';
import { FaArrowAltCircleLeft, FaArrowAltCircleRight, FaCreditCard, FaMoneyBillWave, FaUniversity } from 'react-icons/fa';
import "./InvoiceReservationWebPage.css";
import PaymentReservationConfirmationMessage from '../../components/web/reservations/PaymentReservationConfirmationMessage';
import moment from 'moment';
import { TbCar, TbManualGearbox, TbTruckDelivery } from 'react-icons/tb';
import { RiLuggageDepositFill, RiPriceTag3Fill } from 'react-icons/ri';
import { IoSpeedometerOutline } from 'react-icons/io5';
import { FaChargingStation } from 'react-icons/fa6';
import { ROUTES } from '../../config/routingUrl';
import Carousel from 'react-multi-carousel';

// Clé de chiffrement (doit être stockée de manière sécurisée)


// Fix for missing marker icon issue
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});





const InvoiceReservationWebPage = () => {

    const encryptionKey = "clé-secrète-de-chiffrement"; // Clé de chiffrement
    const currency = "eur"
    const stripe = useStripe();
    const elements = useElements();
    const [errorStripe, setErrorStripe] = useState(null);
    const [success, setSuccess] = useState(false);
    const [customerName, setCustomerName] = useState('');
    const [loadingCard, setloadingCard] = useState(false)


    const navigate = useNavigate();
    const location = useLocation();
    const {
        //more infos reservation
        // CARTE D'IDENTITE
        idCard,
        idCardFile,
        // lIVRET DE FAMILLE
        driverLicenseNumber,
        driverLicenseFile,
        // PERMIS DE CONDUIRE
        permisLicenseNumber,
        permisLicenseFile,
        dateOfBirth,
        pickupLocation,
        returnLocation,
        // other
        reservationElement, type, vehicle, firstname, image, property,
        userAdd,
        basePricePerDay,
        commissionPercentage,
        deliveryFee,
        lastname, email, phone, codePostal, numberTVA, startDate, endDate, specialRequests,
        // localisation
        latStart,
        lngStart,
        latEnd,
        lngEnd,
        companyAirport,
        numberVolAiport

    } = location.state || {};

    const dispatch = useDispatch();

    const companyairports = useSelector((state) => state.companyairports.companyairports)

    const loadingReservation = useSelector((state) => state.reservations.loadingReservation);
    const vehicleData = useSelector((state) => state.vehicles.vehicle);
    const propertyData = useSelector((state) => state.propertys.property);
    const codepostals = useSelector((state) => state.codepostals.codepostals);
    const vehicles = useSelector((state) => state.vehicles.vehiclesAvailable);
    const propertys = useSelector((state) => state.propertys.propertysAvailable);

    const [euroToDinar, setEuroToDinar] = useState(0);

    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 1200 },
            items: 4,
        },
        desktop: {
            breakpoint: { max: 1200, min: 992 },
            items: 4,
        },
        tablet: {
            breakpoint: { max: 992, min: 768 },
            items: 2,
        },
        mobile: {
            breakpoint: { max: 768, min: 0 },
            items: 1,
        },
    };

    const [formData, setFormData] = useState({
        activateReservation: false,
    });

    useEffect(() => {

        dispatch({ type: FETCH_RESERVATION_SUCCESS });
        if (!userAdd) {
            // toast.error("Veillez rempir les champs du formualire s'il vous plais")
            navigate(`/`);
        }
        setpaymentMethodR("bank")
        setBankInfo({
            ...bankInfo,
            accountNumber: baseurl.W68bAVn7ps26XtNsxrZKgr955HJ3DNrK843krdnp2pP563BmppBJ,
            bankName: baseurl.Zd3bJrnkpsBH8pXB38nJK6V59spNp6WNPA6tp5Km25rx6274grrD,
            iban: baseurl.A6mbd3nNrsrpkN67r5HW4g56JpPX2K8VZrD28JB3snx65t3pKB9pp,
            swiftCode: baseurl.p3kb86nJrsDmWZ8KBxJdrX2A2g69prprt5H6p7B5PK5NpNs364Vn
        })
        handleVerifyActivationAccompteUser();
        dispatch(fetchCompanyAiportsAll())
        dispatch(fetchCodePostalsAll());
        dispatch(fetchVehicleById(vehicle));
        dispatch(fetchPropertyById(property));
        // dispatch(fetchVehiclesAllResearchAvailable(currentDate, currentDate));
        // dispatch(fetchPropertysAllResearchAvailable(currentDate, currentDate));

        async function getExchangeRate() {
            const { buyRate } = await fetchExchangeRateGetCurency("EUR");
            setEuroToDinar(buyRate || getAndCheckLocalStorage(localStorageData.ExchangeRateGetNow));
            // console.log(getAndCheckLocalStorage(localStorageData.ExchangeRateGetNow))
        }
        getExchangeRate();
        fetchUserByGet()
    }, [dispatch])




    const [filteredVehicles, setFilteredVehicles] = useState([]);
    const [filteredProperties, setFilteredProperties] = useState([]);
    // État pour gérer le survol de chaque élément
    const [hoverStates, setHoverStates] = useState({});

    // Fonction pour mettre à jour l'état de survol d'un élément spécifique
    const handleMouseEnter = (id) => {
        setHoverStates((prevState) => ({
            ...prevState,
            [id]: true,
        }));
    };

    const handleMouseLeave = (id) => {
        setHoverStates((prevState) => ({
            ...prevState,
            [id]: false,
        }));
    };


    useEffect(() => {
        // Filtrage basé sur le prix
        const vehiclesFiltered = vehicles || []
        const propertiesFiltered = propertys || []
        setFilteredVehicles(vehiclesFiltered);
        setFilteredProperties(propertiesFiltered);
    }, [vehicles, propertys]);



    const currentItems = (vehicleData && vehicleData._id)
        ? filteredVehicles
        : filteredProperties;


    const [showModal, setShowModal] = useState(false);
    const [promoCode, setPromoCode] = useState('');

    const vehicleInfo = {
        name: vehicle?.brand || vehicleData?.brand,
        image: vehicle?.image || emptyImage,
        type: type,
        basePricePerDay: basePricePerDay, // Prix journalier en DZD
        deliveryFee: deliveryFee || 0, // Frais de livraison
        commissionPercentage: commissionPercentage || 0, // Pourcentage de commission
        discount: 0, // Remise initiale
        deliveryFee10: Number(vehicleData?.deliveryFee10 || vehicle?.deliveryFee10 || 0),
        deliveryFee20: Number(vehicleData?.deliveryFee20 || vehicle?.deliveryFee20 || 0),
        deliveryFee30: Number(vehicleData?.deliveryFee30 || vehicle?.deliveryFee30 || 0),
        deliveryFee40: Number(vehicleData?.deliveryFee40 || vehicle?.deliveryFee40 || 0),
        deliveryFee50: Number(vehicleData?.deliveryFee50 || vehicle?.deliveryFee50 || 0),
        deliveryFee60: Number(vehicleData?.deliveryFee60 || vehicle?.deliveryFee60 || 0),
        deliveryFee70: Number(vehicleData?.deliveryFee70 || vehicle?.deliveryFee70 || 0),
        deliveryFee80: Number(vehicleData?.deliveryFee80 || vehicle?.deliveryFee80 || 0),
        deliveryFee90: Number(vehicleData?.deliveryFee90 || vehicle?.deliveryFee90 || 0),
        deliveryFee100: Number(vehicleData?.deliveryFee100 || vehicle?.deliveryFee100 || 0),
        deliveryFee110: Number(vehicleData?.deliveryFee110 || vehicle?.deliveryFee110 || 0),
        deliveryFee120: Number(vehicleData?.deliveryFee120 || vehicle?.deliveryFee120 || 0),
        deliveryFee130: Number(vehicleData?.deliveryFee130 || vehicle?.deliveryFee130 || 0),
        deliveryFee140: Number(vehicleData?.deliveryFee140 || vehicle?.deliveryFee140 || 0),
        deliveryFee150: Number(vehicleData?.deliveryFee150 || vehicle?.deliveryFee150 || 0),
        deliveryFee160: Number(vehicleData?.deliveryFee160 || vehicle?.deliveryFee160 || 0),
        deliveryFee170: Number(vehicleData?.deliveryFee170 || vehicle?.deliveryFee170 || 0),
        deliveryFee180: Number(vehicleData?.deliveryFee180 || vehicle?.deliveryFee180 || 0),
        deliveryFee190: Number(vehicleData?.deliveryFee190 || vehicle?.deliveryFee190 || 0),
        deliveryFee200: Number(vehicleData?.deliveryFee200 || vehicle?.deliveryFee200 || 0),

    };

    const userInfo = {
        firstName: firstname,
        lastName: lastname,
        phone: phone,
        email: email,
    };



    async function fetchUserByGet() {
        await axios.get(
            `${baseurl.url}/api/v1/users/get_user/${userAdd}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
                }
            }).then((response) => {
                console.log(response.data.data);
                const responseData = response.data.data;
                // Mettre à jour formData correctement en utilisant prevState
                setFormData(prevState => ({
                    ...prevState,
                    activateReservation: responseData?.activateReservation || false
                }));
            })
            .catch((error) => {
                // dispatch({ type: FETCH_USER_FAILURE, payload: error.message })
                console.log(error.message);
            });
    }

    // Fonction pour calculer la durée en jours, heures, minutes
    const calculateDuration = (startDate, endDate) => {
        const start = new Date(startDate);
        const end = new Date(endDate);
        const durationInMs = end - start;
        const durationInHours = durationInMs / (1000 * 60 * 60);

        let days = Math.floor(durationInHours / 24);
        let hours = Math.floor(durationInHours % 24);
        let minutes = Math.floor((durationInHours % 1) * 60);

        // Si on dépasse l'heure ou les minutes, on arrondit au jour suivant
        if (hours > 0 || minutes > 0) {
            days += 1;  // Ajout d'un jour supplémentaire si on dépasse
            hours = 0;  // On remet les heures à 0
            minutes = 0; // On remet les minutes à 0
        }
        return { days, hours, minutes };
    };

    // Calcul de la durée entre startDate et endDate
    const duration = calculateDuration(startDate, endDate);



    function calculateDistance(lat1, lon1, lat2, lon2) {
        const R = 6371; // Rayon de la Terre en kilomètres
        const dLat = (lat2 - lat1) * (Math.PI / 180);
        const dLon = (lon2 - lon1) * (Math.PI / 180);

        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        const distance = R * c; // Distance en kilomètres
        return distance || 0;
    }

    const [distanceDelyverie, setDistanceDelyverie] = useState(0);

    // Utiliser useEffect pour calculer la distance une fois que les données sont disponibles
    useEffect(() => {
        // Vérifie que toutes les coordonnées sont définies avant de calculer la distance
        if (vehicleData?.lat && vehicleData?.lng && latStart && lngStart) {
            const distance = calculateDistance(vehicleData?.lat, vehicleData?.lng, latStart, lngStart);
            setDistanceDelyverie(distance);
        }
    }, [vehicleData?.lat, vehicleData?.lng, latStart, lngStart]);

    // Correctif pour les conditions de calcul des frais de livraison
    const vehicleDeveliView = Number(
        distanceDelyverie >= 10 && distanceDelyverie < 50 ? (vehicleData?.deliveryFee10 ?? vehicleInfo?.deliveryFee10 ?? 0) :
            distanceDelyverie >= 50 && distanceDelyverie < 100 ? (vehicleData?.deliveryFee50 ?? vehicleInfo?.deliveryFee50 ?? 0) :
                distanceDelyverie >= 100 && distanceDelyverie < 200 ? (vehicleData?.deliveryFee100 ?? vehicleInfo?.deliveryFee100 ?? 0) :
                    distanceDelyverie >= 200 ? (vehicleData?.deliveryFee200 ?? vehicleInfo?.deliveryFee200 ?? 0) : 0
    );



    // Calcul du prix total en tenant compte des jours et des frais de livraison
    const calculateTotalPrice = () => {
        const { days } = calculateDuration(startDate, endDate);

        // Prix pour les jours entiers
        const totalPriceForDays = days * Number(vehicleInfo?.basePricePerDay || 0);
        console.log("totalPriceForDays  : ", totalPriceForDays);

        // Total avant frais de livraison et remises
        const subTotal = totalPriceForDays;
        console.log("subTotal  : ", subTotal);

        // Ajout de la commission
        const commission = (subTotal * Number(vehicleInfo?.commissionPercentage || 0)) / 100;
        console.log("commission  :  ", commission);

        // Calcul des frais de livraison en fonction de la distance
        const vehicleDeliveryFee = Number(vehicleDeveliView || deliveryFee || 0);
        console.log("vehicleDeliveryFee : ", vehicleDeliveryFee);

        const discount = Number(vehicleInfo?.discount || 0);
        console.log("vehicleInfo?.discount : ", discount);

        // Calcul du prix total
        const totalPrice = subTotal + vehicleDeliveryFee + commission - discount;
        console.log("totalPrice : ", totalPrice);

        return totalPrice;
    };

    // Total à afficher
    const totalPrice = calculateTotalPrice();


    const handleShowModal = () => {
        handleVerifyActivationAccompteUser()
        if (!paymentMethodR) {
            toast.error("Veillez choisir le réglement du paiement de la réservation")
            return;
        }
        setShowModal(true)
    }
    const handleCloseModal = () => setShowModal(false);
    const handleConfirmReservation = () => {
        setShowModal(false);
        handleSubmit();
    }


    const handleVerifyActivationAccompteUser = async () => {
        dispatch({ type: FETCH_RESERVATION_REQUEST });

        await axios.get(
            `${baseurl.url}/api/v1/users/get_user/${userAdd}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
                }
            }
        ).then(async (response) => {
            console.log("Réponse API :", response.data.data);
            const responseData = response.data.data;
            setFormData(prevState => ({
                ...prevState,
                activateReservation: responseData?.activateReservation || false
            }));
            dispatch({ type: FETCH_RESERVATION_SUCCESS, payload: responseData });
        }).catch((error) => {
            dispatch({ type: FETCH_RESERVATION_FAILURE, payload: error.message });
            console.log("❌ Erreur API :", error);
            setloadingCard(false)
        })
    }






    const [verifyReservation, setverifyReservation] = useState(false);
    const checkAvailabilityReservationAndMaintenanceSubmit = async (startDate, endDate, propertyId, vehicleId, userAdd) => {
        setverifyReservation(false);
        dispatch({ type: FETCH_RESERVATION_REQUEST });
        const params = new URLSearchParams();
        if (startDate) params.append("startDate", startDate);
        if (endDate) params.append("endDate", endDate);
        if (propertyId) params.append("propertyId", propertyId);
        if (vehicleId) params.append("vehicleId", vehicleId);
        if (userAdd) params.append("userAdd", userAdd);

        try {
            const response = await axios.get(`${baseurl.url}/api/v1/reservations/check-availability?${params.toString()}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
                }
            });
            dispatch({ type: FETCH_RESERVATION_SUCCESS });
            setverifyReservation(response.data.success);
            return response.data.success;  // ✅ Retourne la vraie valeur de l'API
        } catch (error) {
            //   console.error("🚨 Erreur API Vérification Disponibilité :", error);
            dispatch({ type: FETCH_RESERVATION_FAILURE });
            setverifyReservation(false);
            toast.error(error?.response?.data?.message || "Vérification de la disponibilité échouée. Veuillez réessayer.");
            return false;  // ✅ Toujours retourner `false` en cas d'erreur
        }
    };



    // crédit card
    const [paymentMethod, setPaymentMethod] = useState("");
    const [paymentMethodR, setpaymentMethodR] = useState("cash");
    const [cardInfo, setCardInfo] = useState({ number: "", name: "", expiry: "", cvc: "" });
    const [bankInfo, setBankInfo] = useState({ accountNumber: "", bankName: "", iban: "", swiftCode: "" });
    const [loading, setLoading] = useState(false);

    const handlePaymentChange = (e) => {
        setPaymentMethod(e.target.value);
    };

    const handleCardChange = (e) => {
        setCardInfo({ ...cardInfo, [e.target.name]: e.target.value });
    };

    const handleExpiryChange = (e) => {
        let value = e.target.value.replace(/\D/g, ""); // Supprime tous les caractères non numériques

        if (value.length > 2) {
            value = `${value.slice(0, 2)}/${value.slice(2, 4)}`; // Ajoute `/` après les deux premiers chiffres
        }

        setCardInfo({ ...cardInfo, expiry: value });
    };

    const handleBankChange = (e) => {
        setBankInfo({ ...bankInfo, [e.target.name]: e.target.value });
    };

    // Fonction pour chiffrer les données sensibles
    const encryptData = (data) => {
        return CryptoJS.AES.encrypt(JSON.stringify(data), encryptionKey).toString();
    };

    const handlePaymentChoice = (method) => {
        setPaymentMethod(method);
        // onSelectPayment(method);
    };





    const handleSubmit = async (e) => {

        e.preventDefault();

        const { buyRate } = await fetchExchangeRateGetCurency("EUR");
        setEuroToDinar(buyRate || getAndCheckLocalStorage(localStorageData.ExchangeRateGetNow || 0))

        let reservationData = {
            code: promoCode,
            type, vehicle, property,
            basePricePerDay: Number(basePricePerDay),
            commissionPercentage: Number(commissionPercentage),
            deliveryFee: Number(deliveryFee),
            discount: Number(vehicleInfo.discount),
            firstname, lastname, email, phone, codePostal, numberTVA, startDate, endDate, specialRequests,
            userAdd,
            // more informations
            idCard,
            idCardFile,
            // lIVET DE FAMILLE 
            driverLicenseNumber,
            driverLicenseFile,
            // PERMIS DE CONDUIRE
            permisLicenseNumber: permisLicenseNumber,
            permisLicenseFile: permisLicenseFile,
            dateOfBirth,
            pickupLocation,
            returnLocation,

            latStart,
            lngStart,
            latEnd,
            lngEnd,

            //  information sur la le vol
            companyAirport,
            numberVolAiport,

            //information  sur la carte de credit
            customerName: customerName,
            euroToDinar: euroToDinar || 0,
            creditCard: '',
            // options du payment
            cardHolderName: cardInfo.name,
            cardLast4Digits: cardInfo.number.slice(-4),
            cardBrand: "Visa", // Déterminer la marque selon le numéro
            expirationMonth: cardInfo.expiry.split("/")[0],
            expirationYear: cardInfo.expiry.split("/")[1],
            informationObject: encryptData(cardInfo),
            amount: euroToDinar, // 10% acompte
            amountReal: totalPrice,
            paymentMethod: paymentMethod,// moyen de paiement pour l'acompte 
            paymentMethodR: paymentMethodR,// moyen de paiement de la réservation
            // Information de la banck : 
        };

        // Vérification de disponibilité du vehocule our la reservation . 
        const isAvailable = await checkAvailabilityReservationAndMaintenanceSubmit(startDate, endDate, property, vehicle, userAdd);
        if (!isAvailable) {
            toast.error("Une réservation ou une maintenance existe déjà sur cette période. Veuillez choisir une autre date.");
            // setisLoading(false);
            return;
        }





        //  reservation simple
        if (userAdd) {
            console.log("Utilisateur propriétaire du patrimone ", userAdd)
            //  verfier que l'utilisateur activer l'option 10%
            dispatch({ type: FETCH_RESERVATION_REQUEST });
            await axios.get(
                `${baseurl.url}/api/v1/users/get_user/${userAdd}`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
                    }
                }
            ).then(async (response) => {
                console.log("Réponse API :", response.data.data);
                const responseData = response.data.data;
                setFormData(prevState => ({
                    ...prevState,
                    activateReservation: responseData?.activateReservation || false
                }));
                dispatch({ type: FETCH_RESERVATION_SUCCESS, payload: responseData });

                console.log("❌ L'activation de la réservation est désactivée.");

                // Ajoute ici l'action à exécuter si activateReservation est FALSE
                dispatch(ReservationCreateClientSimple(reservationData, navigate, toast));
                setloadingCard(false)

                handleVerifyActivationAccompteUser();
                dispatch(fetchCompanyAiportsAll())
                dispatch(fetchCodePostalsAll());
                dispatch(fetchVehicleById(vehicle));
                dispatch(fetchPropertyById(property));

                async function getExchangeRate() {
                    const { buyRate } = await fetchExchangeRateGetCurency("EUR");
                    setEuroToDinar(buyRate || getAndCheckLocalStorage(localStorageData.ExchangeRateGetNow));
                    // console.log(getAndCheckLocalStorage(localStorageData.ExchangeRateGetNow))
                }
                getExchangeRate();
                fetchUserByGet();


                // if (responseData?.activateReservation) {

                //     if (euroToDinar === 0 || euroToDinar < 0) {
                //         // toast.error("montant doit être un montant valide . ", { position: "bottom-right" });
                //         const { buyRate } = await fetchExchangeRateGetCurency("EUR");
                //         setEuroToDinar(buyRate || getAndCheckLocalStorage(localStorageData.ExchangeRateGetNow))
                //         // return;
                //     }

                //     if (!paymentMethod) {
                //         toast.error("Moyen de paiement obligatoire ! ", { position: "bottom-right" });
                //         return;
                //     }

                //     if (paymentMethod === "card") {
                //         // if (!cardInfo.number || !cardInfo.name || !cardInfo.expiry || !cardInfo.cvc) {
                //         //     toast.error("Veuillez remplir toutes les informations de la carte.", { position: "bottom-right" });
                //         //     setLoading(false);
                //         //     return;
                //         // }

                //         let amountFinalEuro = Number(Number(totalPrice * 0.13) / euroToDinar).toFixed(3);
                //         // Vérifier si le montant est inférieur à 0.5 euro
                //         if (amountFinalEuro < 0.5) {
                //             amountFinalEuro = 0.5; // Ajuster à 0.5 euro
                //         }
                //         try {

                //             setErrorStripe("");
                //             setloadingCard(true)

                //             reservationData = {
                //                 ...reservationData,
                //                 amount: Number(amountFinalEuro),
                //                 paymentMethod: paymentMethod,
                //                 cardHolderName: cardInfo.name,
                //                 cardLast4Digits: cardInfo.number.slice(-4), // ✅ Identifie la carte sans stocker tout le numéro
                //                 cardBrand: "Visa", // Déterminer la marque si nécessaire
                //                 expirationMonth: cardInfo.expiry.split("/")[0], // ✅ MM formaté
                //                 expirationYear: cardInfo.expiry.split("/")[1], // ✅ YY formaté
                //                 encryptedCardData: encryptData(cardInfo),
                //             };
                //             const { data } = await axios.post(`${baseurl.url}/create-payment-intent`, {
                //                 amount: Number(amountFinalEuro), // 10% de l'acompte
                //                 currency,
                //                 customerName,
                //                 userAdd: userAdd,
                //                 amountReal: totalPrice,
                //                 tauxEuroToDinar: euroToDinar
                //             },
                //                 {
                //                     headers:
                //                     {
                //                         'Content-Type': 'application/json',
                //                         'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
                //                     }
                //                 }
                //             );
                //             const clientSecret = data?.clientSecret;

                //             // Confirmer le paiement avec Stripe
                //             const paymentResult = await stripe?.confirmCardPayment(clientSecret, {
                //                 payment_method: {
                //                     card: elements.getElement(CardNumberElement),
                //                     billing_details: {
                //                         name: customerName,
                //                     },
                //                 },
                //             });

                //             if (paymentResult.error) {

                //                 setShowModal(false);
                //                 setloadingCard(false);
                //                 setSuccess(false);
                //                 toast.error(paymentResult?.error?.message || "Paiement échoué")
                //                 setErrorStripe(paymentResult?.error?.message);
                //                 setTimeout(() => {
                //                     setErrorStripe("");
                //                 }, 10000);

                //             }
                //             else {
                //                 const responseCardId = data?.data?._id;
                //                 reservationData.creditCard = responseCardId
                //                 setSuccess(false);
                //                 setErrorStripe("");
                //                 // console.log("Paiement réussi :", paymentResult);
                //                 setloadingCard(false)
                //                 setShowModal(false);
                //                 toast.success("Paiement réussi ", { position: "bottom-right" });
                //                 dispatch(ReservationCreateClient(reservationData, navigate, toast));

                //                 handleVerifyActivationAccompteUser();
                //                 dispatch(fetchCompanyAiportsAll())
                //                 dispatch(fetchCodePostalsAll());
                //                 dispatch(fetchVehicleById(vehicle));
                //                 dispatch(fetchPropertyById(property));

                //                 async function getExchangeRate() {
                //                     const { buyRate } = await fetchExchangeRateGetCurency("EUR");
                //                     setEuroToDinar(buyRate || getAndCheckLocalStorage(localStorageData.ExchangeRateGetNow));
                //                     // console.log(getAndCheckLocalStorage(localStorageData.ExchangeRateGetNow))
                //                 }
                //                 getExchangeRate();
                //                 fetchUserByGet();
                //             }

                //         } catch (error) {
                //             setloadingCard(false);
                //             setErrorStripe("Une erreur s'est produite lors du traitement du paiement.");
                //             // console.error("Erreur :", error);
                //             toast.error("Une erreur s'est produite lors du traitement du paiement.", { position: "bottom-right" })
                //             setTimeout(() => {
                //                 setErrorStripe("");
                //             }, 10000);
                //         }
                //     }


                //     if (paymentMethod === "bank") {
                //         if (!bankInfo.accountNumber || !bankInfo.bankName || !bankInfo.iban || !bankInfo.swiftCode) {
                //             toast.error("Veuillez remplir toutes les informations bancaires.", { position: "bottom-right" });
                //             setLoading(false);
                //             return;
                //         }
                //         reservationData = {
                //             ...reservationData,
                //             paymentMethod: paymentMethod,
                //             encryptedBankData: encryptData(bankInfo),
                //         };
                //         dispatch(ReservationCreateClient(reservationData, navigate, toast))
                //     }
                //     // Mettre à jour formData en conservant les autres valeurs

                // } else {
                //     console.log("❌ L'activation de la réservation est désactivée.");

                //     // Ajoute ici l'action à exécuter si activateReservation est FALSE
                //     dispatch(ReservationCreateClientSimple(reservationData, navigate, toast));
                //     setloadingCard(false)

                //     handleVerifyActivationAccompteUser();
                //     dispatch(fetchCompanyAiportsAll())
                //     dispatch(fetchCodePostalsAll());
                //     dispatch(fetchVehicleById(vehicle));
                //     dispatch(fetchPropertyById(property));

                //     async function getExchangeRate() {
                //         const { buyRate } = await fetchExchangeRateGetCurency("EUR");
                //         setEuroToDinar(buyRate || getAndCheckLocalStorage(localStorageData.ExchangeRateGetNow));
                //         // console.log(getAndCheckLocalStorage(localStorageData.ExchangeRateGetNow))
                //     }
                //     getExchangeRate();
                //     fetchUserByGet();
                // }
                // si la l'accompte n'est pas activer 

            }).catch((error) => {
                dispatch({ type: FETCH_RESERVATION_FAILURE, payload: error.message });
                console.log("❌ Erreur API :", error);
                setloadingCard(false)
            });
        }
    };



    // Options de moyens de paiement
    const paymentMethods = [

        {
            id: "card",
            label: "Carte de crédit",
            icon: <FaCreditCard size={40} />,
        },
        {
            id: "bank",
            label: "Virement bancaire",
            icon: <FaUniversity size={40} />,
        },
        {
            id: "cash",
            label: "En espèce",
            icon: <FaMoneyBillWave size={40} />,
        },
        // {
        //   id: "other",
        //   label: "Moyen de paiement",
        //   icon: <BiIdCard />,
        // },
    ];


    // Fonction pour gérer la sélection du moyen de paiement
    const handlePaymentMethodChange = (methodId) => {
        setpaymentMethodR(methodId);
    };



    // Etapes
    const [currentStep, setCurrentStep] = useState(1);
    // Données des étapes
    const steps = [
        { id: 1, title: "Étape 1 :", description: "Informations personnelles" },
        { id: 2, title: "Étape 2 :", description: "Informations administratives" },
        { id: 3, title: "Étape 3 :", description: "Informations supplémentaires" },
        { id: 4, title: "Étape 4 :", description: "Résumé et validation" },
    ];
    const handleStepClick = (stepId) => {
        setCurrentStep(stepId); // Mettre à jour l'étape active
    };



    // Fonction pour passer à l'étape suivante
    const handleNextStep = () => {
        if (currentStep < steps.length) {
            setCurrentStep(currentStep + 1);
        }
    };

    // Fonction pour revenir à l'étape précédente
    const handlePreviousStep = () => {
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
        }
    };


    const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 992);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <Container fluid className="container-fluid" style={{ padding: "100px 0px 0px 0px", background: "#F5FDF7" }}>

            <div className="container" style={{ position: "relative", zIndex: 65 }}>
                <div className="pb-5">
                    <div>
                        <Button className="" onClick={() => { navigate(-1) }} variant="dark" style={{ borderRadius: "20px", padding: "10px 10px 10px 10px" }}>
                            <span className="bg-white rounded-lg"><FaArrowAltCircleLeft color={"#42B711"} size={30} /></span>  <span className="px-3"> Retour </span></Button>
                    </div>
                </div>
                <div className="row">
                    <Col md={5}>
                        <div className="" style={{ height: '100%', }}>
                            <div>
                                {/* Galerie d'images */}

                                {
                                    vehicleData &&
                                    vehicleData.images &&
                                    vehicleData.images && (
                                        <div
                                            style={{
                                                height: "250px", // Hauteur fixe
                                                width: "100%",
                                                overflow: "hidden",
                                                borderRadius: "15px", // Coins arrondis pour le conteneur
                                            }}
                                        >
                                            <Image
                                                src={vehicleData.images[0] || emptyImage}
                                                className="img-fluid rounded-md"
                                                alt=""
                                                style={{
                                                    height: "250px",
                                                    width: "100%",
                                                    objectFit: "fill",
                                                    borderRadius: "15px", // Coins arrondis pour l'image
                                                }}
                                            />
                                        </div>
                                    )
                                }
                                {
                                    propertyData &&
                                    propertyData.images &&
                                    propertyData.images && (
                                        <div
                                            style={{
                                                height: "250px", // Hauteur fixe
                                                width: "100%",
                                                overflow: "hidden",
                                                borderRadius: "15px", // Coins arrondis pour le conteneur
                                            }}
                                        >
                                            <Image
                                                src={propertyData.images[0] || emptyImage}
                                                className="img-fluid rounded-md"
                                                alt=""
                                                style={{
                                                    height: "250px",
                                                    width: "100%",
                                                    objectFit: "fill",
                                                    borderRadius: "15px", // Coins arrondis pour l'image
                                                }}
                                            />
                                        </div>
                                    )
                                }


                            </div>
                        </div>
                    </Col>
                    <Col md={7}>
                        <div className=" rounded-5  m-b40 m-sm-b0">
                            <div className="">
                                <div>
                                    <div className="dlab-post-title">
                                        <h3 className="post-title">
                                            <Link to="javascript:void(0);" style={{ fontSize: "32px", color: "black" }}>{vehicleData?.brand || property?.name || ""}</Link>
                                        </h3>
                                        {/*<h6 className="sub-title">{vehicle?.type?.name || ""}</h6> */}
                                        <div style={{ display: "flex", alignContent: "center" }}>
                                            <span style={{ fontWeight: "bold", color: "black", fontSize: "32px" }} className="font-bold"> {vehicleData?.basePricePerDay || property?.basePricePerDay || 0} </span>
                                            <span style={{ fontWeight: "bold", color: "black", fontSize: "32px" }} className="px-1"> DZD </span>
                                            <span style={{ color: "#A6A6A6", fontSize: "20px", textAlign: "end" }} className="px-1 pt-2"> /Jour</span>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                                            <div><MdDateRange /> {moment(startDate).format("DD/MM/YYYY")} - {moment(endDate).format("DD/MM/YYYY")}</div>
                                            <div><MdOutlineTimer /> {moment(startDate).format("HH:mm")} - {moment(endDate).format("HH:mm")}</div>
                                            {
                                                <div><MdToday /> {duration.days} jour{duration.days > 1 ? "s" : ""}</div>
                                            }
                                        </div>
                                    </div>

                                    {/* ✅ Caractéristiques du véhicule */}

                                </div>
                            </div>
                        </div>
                    </Col>
                    {/*options supplementaires */}
                </div>

            </div>



            <div className="container-fluid " style={{ position: "relative", zIndex: 60, top: -35, background: "linear-gradient(90deg, #43B613, #1D5008)", padding: "110px 10px 100px 10px" }}>
                <div className="container bg-transparent" style={{ position: "relative", zIndex: 70 }}>
                    <div className="row" style={{ background: "transparent", padding: "10px 5px 50px 5px" }} >
                        {
                            currentStep == 1 && (
                                <>
                                    <Col md={6} >


                                        <div className="bg-transparent text-white p-4">
                                            {/* Prix journalier */}
                                            <Row>
                                                <Col md={12}>
                                                    <Row>
                                                        <div><h3 className="" style={{ fontSize: "18px", color: "#FFFFFFDE" }}> <RiPriceTag3Fill size={20} /> <span>Prix total réservation </span></h3></div>
                                                        <div>
                                                            <span style={{ fontSize: "2rem", fontWeight: "bold" }}>{Number(vehicleInfo.basePricePerDay * duration.days) || "0"} DZD</span>
                                                        </div>
                                                    </Row>
                                                </Col>
                                            </Row>

                                            {/* Frais de livraison */}
                                            <Row>
                                                <Col md={12}>
                                                    <Row>
                                                        <div>
                                                            <h3 className="" style={{ fontSize: "18px", color: "#FFFFFFDE" }}>

                                                                {reservationElement == "Vehicle" ? <span> <TbCar /> Frais de livraison</span> : ""}
                                                                {reservationElement == "Property" ? <span> <MdOutlineMoneyOff /> Frais </span> : ""}</h3>
                                                        </div>
                                                        <div>
                                                            <span style={{ fontSize: "2rem", fontWeight: "bold" }}>
                                                                {reservationElement == "Vehicle" ? Number(vehicleDeveliView || 0) + "DZD" : ""}
                                                                {reservationElement == "Property" ? Number(vehicleInfo.deliveryFee || 0) + "DZD" : ""}
                                                            </span>
                                                        </div>
                                                    </Row>
                                                </Col>
                                            </Row>


                                            {/*
                                                formData?.activateReservation && (
                                                    <Row>
                                                        <Col md={12}>
                                                            <div>
                                                                <h3 className="" style={{ fontSize: "18px", color: "#FFFFFFDE" }}> <RiLuggageDepositFill /> {"Accompte"}</h3>
                                                            </div>
                                                            <div>
                                                                <p style={{ fontSize: "2rem", fontWeight: "bold" }}>{(Number(totalPrice) * 0.13).toFixed(1)} DZD</p>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                )
                                                     */
                                            }

                                            {/* Ligne de séparation */}
                                            <hr style={{ color: "#FFFFFFDE" }} />

                                            {/* Total à payer */}
                                            <Row>
                                                <Col md={12}>
                                                    <Row>
                                                        <div>
                                                            <p style={{ fontSize: "3rem", fontWeight: "bold" }}>{totalPrice.toFixed(1).toLocaleString() || 0} DZD
                                                                <span style={{ color: "#FFFFFFDE", fontSize: "18px", textAlign: "end" }} className="px-1 pt-2"> /TOTAL À PAYER

                                                                </span>
                                                            </p>
                                                        </div>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>

                                    <Col md={6} >

                                        <div className=" text-white p-4">
                                            <h3 style={{ fontSize: "18px", color: "#FFFFFFDE" }}>Moyen de paiement de la réservation</h3>
                                            <Row>
                                                {paymentMethods.map((method) => (
                                                    <Col md={6} key={method.id}>
                                                        <div
                                                            className={`d-flex align-items-center justify-content-center mt-3 ${paymentMethodR === method.id ? "border border-2 border-white" : ""
                                                                }`}
                                                            style={{
                                                                height: "150px",
                                                                // width:"120px",
                                                                padding: "20px",
                                                                borderRadius: "10px",
                                                                cursor: "pointer",
                                                                backgroundColor: paymentMethodR === method.id ? "#55913d" : "#55913d",
                                                                color: "#fff",
                                                                border: paymentMethodR === method.id ? "2px #fff solid" : "2px transparent solid"
                                                            }}
                                                            onClick={() => handlePaymentMethodChange(method.id)}
                                                        >
                                                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                                {method.icon}
                                                                <span className="mt-2">{method.label}</span>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                ))}
                                            </Row>
                                        </div>
                                    </Col>
                                </>
                            )
                        }


                        {
                            currentStep == 2 && (
                                <Col md={12}>

                                    <div style={{ display: "flex", width: "100%", flexDirection: "column", justifyContent: "center" }}>
                                        {/*style={{ backgroundColor: "#43B613" }} */}
                                        <div>
                                            {reservationElement == "Vehicle" ?
                                                <p className="text-center text-white">Êtes-vous sûr de vouloir confirmer la réservation du véhicule <strong>{vehicleData && vehicleData.brand ? vehicleData.brand : ""}</strong> </p>
                                                : ""}
                                            {reservationElement == "Property" ?
                                                <p className="text-center text-white">Êtes-vous sûr de vouloir confirmer la réservation de la propriété <strong> {propertyData && propertyData.name ? propertyData.name : ""}</strong> </p>
                                                : ""}
                                            <br />
                                        </div>

                                        {/*<strong>Montant total :</strong> {totalPrice.toLocaleString()} DZD */}



                                        {/*Stripe */}


                                        {/*formData.activateReservation && (
                                                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", }}>
                                                    <h6 className="text-white text-center">Choix du paiement (Accompte) </h6>
                                                    <div className=" mt-2 mb-2" style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
                                                        <div className="mb-2 mx-2">
                                                            <div
                                                                className={`payment-option`}
                                                                style={{
                                                                    width: "120px",
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    flexDirection: "column",
                                                                    padding: "20px",
                                                                    borderRadius: "10px",
                                                                    cursor: "pointer",
                                                                    backgroundColor: paymentMethod === "card" ? "#55913d" : "#55913d",
                                                                    color: "#fff",
                                                                    border: paymentMethod === "card" ? "2px #fff solid" : "2px transparent solid"
                                                                }}
                                                                onClick={() => handlePaymentChoice("card")}
                                                            >
                                                                <FaCreditCard size={40} className={`payment-icon text-white`} />
                                                                <span className={`text-white`}>Carte de Crédit</span>
                                                            </div>
                                                        </div>


                                                        <div className="mb-2 mx-2">
                                                            <div
                                                                className={`payment-option`}
                                                                style={{
                                                                    width: "120px",
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    flexDirection: "column",
                                                                    padding: "20px",
                                                                    borderRadius: "10px",
                                                                    cursor: "pointer",
                                                                    backgroundColor: paymentMethod === "bank" ? "#55913d" : "#55913d",
                                                                    color: "#fff",
                                                                    border: paymentMethod === "bank" ? "2px #fff solid" : "2px transparent solid"
                                                                }}
                                                                onClick={() => handlePaymentChoice("bank")}
                                                            >
                                                                <FaUniversity size={40} className={`payment-icon text-white`} />
                                                                <span className={`text-white`}>Virement bancaire</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="container-fluid" style={{ width: "100%", justifyContent: "center" }}>
                                                        <div className="container" style={{ width: !isMobile ? "50%" : "100%" }}>
                                                            {
                                                                paymentMethod === "card" && (
                                                                    <>
                                                                        <div className="col-md-12 form-group" style={{ marginBottom: "15px", }}>
                                                                            <label htmlFor="customerName" className="text-white" style={{ fontWeight: "bold", marginBottom: "5px", display: "block" }}>Nom sur la carte</label>
                                                                            <input
                                                                                className="form-control bg-white"
                                                                                type="text"
                                                                                id="customerName"
                                                                                value={customerName}
                                                                                onChange={(e) => setCustomerName(e.target.value)}
                                                                                placeholder="Entrez le nom complet sur la carte ...."
                                                                                required
                                                                                style={{
                                                                                    fontSize: "16px",
                                                                                    width: "100%",
                                                                                    height: '40px',
                                                                                    background: "#FFFFFF",
                                                                                    borderRadius: "20px", // Bordures arrondies
                                                                                    border: "1px solid black", // Bordure légère pour améliorer la visibilité
                                                                                }}
                                                                            />
                                                                        </div>

                                                                        <div className="col-md-12 form-group border" style={{ marginBottom: "15px", border: "0 0 1px 0 solid" }}>
                                                                            <label htmlFor="cardNumber" className="text-white" style={{ fontWeight: "bold", marginBottom: "5px", display: "block" }}>Numéro de carte</label>
                                                                            <CardNumberElement
                                                                                style={{
                                                                                    fontSize: "16px",
                                                                                    width: "100%",
                                                                                    height: '40px',
                                                                                    background: "#FFFFFF",
                                                                                    borderRadius: "20px", // Bordures arrondies
                                                                                    border: "1px solid black", // Bordure légère pour améliorer la visibilité

                                                                                }}
                                                                            />
                                                                        </div>

                                                                        <div className="col-md-12 form-group border" style={{ marginBottom: "15px", border: "0 0 1px 0 solid" }}>
                                                                            <label htmlFor="expiryDate" className="text-white" style={{ fontWeight: "bold", marginBottom: "5px", display: "block" }}>Date d’expiration</label>
                                                                            <CardExpiryElement
                                                                                style={{
                                                                                    fontSize: "16px",
                                                                                    width: "100%",
                                                                                    height: '40px',
                                                                                    background: "#FFFFFF",
                                                                                    borderRadius: "20px", // Bordures arrondies
                                                                                    border: "1px solid black", // Bordure légère pour améliorer la visibilité

                                                                                }}
                                                                            />
                                                                        </div>

                                                                        <div className="col-md-12 form-group border" style={{ marginBottom: "15px", border: "0 0 1px 0 solid" }}>
                                                                            <label htmlFor="cvc" className="text-white" style={{ fontWeight: "bold", marginBottom: "5px", display: "block" }}>CVC</label>
                                                                            <CardCvcElement className="text-white"
                                                                                style={{

                                                                                    fontSize: "16px",
                                                                                    width: "100%",
                                                                                    height: '40px',
                                                                                    background: "#FFFFFF",
                                                                                    borderRadius: "20px", // Bordures arrondies
                                                                                    border: "1px solid black", // Bordure légère pour améliorer la visibilité

                                                                                }}
                                                                            />
                                                                        </div>





                                                                        {errorStripe && <p style={{ color: 'red', marginTop: "10px" }}>{errorStripe}</p>}
                                                                        {success && <p style={{ color: 'green', marginTop: "10px" }}>Paiement réussi ! Merci, {customerName}.</p>}
                                                                    </>
                                                                )
                                                            }

                                                            {paymentMethod === "bank" && (
                                                                <>
                                                                    <h6 className="text-white"> Informations Bancaire de Mareza</h6>
                                                                    <Form.Group>
                                                                        <Form.Label className="text-white">Numéro de compte</Form.Label>
                                                                        <Form.Control style={{
                                                                            height: '40px',
                                                                            background: "transparent",
                                                                            borderRadius: "20px", // Bordures arrondies
                                                                            border: "1px solid white",
                                                                            color: "white" // Bordure légère pour améliorer la visibilité
                                                                        }} type="text" name="accountNumber" value={bankInfo.accountNumber} placeholder="Numéro de compte" />
                                                                    </Form.Group>
                                                                    <Form.Group>
                                                                        <Form.Label className="text-white">Nom de la banque</Form.Label>
                                                                        <Form.Control style={{
                                                                            height: '40px',
                                                                            background: "transparent",
                                                                            borderRadius: "20px", // Bordures arrondies
                                                                            border: "1px solid white",
                                                                            color: "white" // Bordure légère pour améliorer la visibilité
                                                                        }} type="text" name="bankName" value={bankInfo.bankName} placeholder="Nom de la banque" />
                                                                    </Form.Group>
                                                                    <Form.Group>
                                                                        <Form.Label className="text-white">IBAN</Form.Label>
                                                                        <Form.Control style={{
                                                                            height: '40px',
                                                                            background: "transparent",
                                                                            borderRadius: "20px", // Bordures arrondies
                                                                            border: "1px solid white",
                                                                            color: "white" // Bordure légère pour améliorer la visibilité
                                                                        }} type="text" name="iban" value={bankInfo.iban} placeholder="IBAN" />
                                                                    </Form.Group>
                                                                    <Form.Group>
                                                                        <Form.Label className="text-white">BIC/SWIFT</Form.Label>
                                                                        <Form.Control style={{
                                                                            height: '40px',
                                                                            background: "transparent",
                                                                            borderRadius: "20px", // Bordures arrondies
                                                                            border: "1px solid white",
                                                                            color: "white" // Bordure légère pour améliorer la visibilité
                                                                        }} type="text" name="swiftCode" value={bankInfo.swiftCode} placeholder="BIC/SWIFT" />
                                                                    </Form.Group>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>


                                                </div>
                                            )
                                        */}

                                        <div className="container-fluid" style={{ width: "100%", justifyContent: "center" }}>
                                            <div className="container" style={{ width: "50%" }}>
                                                <Form>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="text-white">Code Promo</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Entrez un code promo"
                                                            className="border border-dark"
                                                            value={promoCode}
                                                            style={{
                                                                height: '40px',
                                                                background: "#FFFFFF",
                                                                borderRadius: "20px", // Bordures arrondies
                                                                border: "1px solid black", // Bordure légère pour améliorer la visibilité
                                                            }}
                                                            onChange={(e) => {
                                                                const inputValue = e.target.value; // Récupérer la valeur saisie
                                                                if (inputValue.length <= 30) {
                                                                    setPromoCode(inputValue); // Mettre à jour la valeur si elle ne dépasse pas 30 caractères
                                                                }
                                                            }}
                                                        />
                                                    </Form.Group>
                                                </Form>

                                                {
                                                    //information dur le moyment d epaiement de la réservation
                                                    <PaymentReservationConfirmationMessage paymentMethodR={paymentMethodR} />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            )}

                        <Col md={12}>
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <div>
                                    {
                                        currentStep == 2 && (
                                            <Button className="" onClick={() => {
                                                if (currentStep == 2) {
                                                    handlePreviousStep();
                                                }
                                            }} variant="dark" style={{ borderRadius: "20px", padding: "10px 10px 10px 10px" }}>
                                                <span className="bg-white rounded-lg"><FaArrowAltCircleLeft color={"#42B711"} size={30} /></span>  <span className="px-3"> Retour </span>
                                            </Button>
                                        )
                                    }

                                </div>
                                <div>
                                    {
                                        loadingReservation ?
                                            <>
                                                <Button
                                                    type="button"
                                                    variant="outline-success"
                                                    style={{
                                                        backgroundColor: "#fff",
                                                        color: "#008000",
                                                        border: "1px solid #008000",
                                                        borderRadius: "25px",
                                                        padding: "20px 30px 20px 30px",
                                                        fontSize: "16px",
                                                        fontWeight: "bold",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        gap: "8px",
                                                        transition: "background-color 0.3s ease, transform 0.3s ease", // Animation fluide
                                                    }}
                                                >
                                                    <Spinner
                                                        variant='primary'
                                                        animation="border"
                                                        size="sm"
                                                        role="status"
                                                        style={{ marginRight: '5px' }}
                                                    >
                                                        <span className="visually-hidden">Loading...</span>
                                                    </Spinner>
                                                    Chargement...
                                                </Button>
                                            </> :

                                            currentStep == 1 ? (
                                                <Button
                                                    type="button"
                                                    variant="outline-success"
                                                    style={{
                                                        backgroundColor: "#fff",
                                                        color: "#008000",
                                                        border: "1px solid #008000",
                                                        borderRadius: "25px",
                                                        padding: "20px 30px 20px 30px",
                                                        fontSize: "16px",
                                                        fontWeight: "bold",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        gap: "8px",
                                                        transition: "background-color 0.3s ease, transform 0.3s ease", // Animation fluide
                                                    }}
                                                    onClick={() => {
                                                        if (!paymentMethodR) {
                                                            toast.error("Veillez sectionez le moyen de paiement de la réservation")
                                                            return;
                                                        }
                                                        handleNextStep()
                                                    }}
                                                >
                                                    <span className="text-dark"> Continuer </span>
                                                    <span style={{ background: "white", borderRadius: "50%" }}>
                                                        <FaArrowAltCircleRight color={"#43B613"} size={20} />
                                                    </span>
                                                </Button>
                                            ) :
                                                currentStep == 2 ?
                                                    (
                                                        <form onSubmit={handleSubmit}>
                                                            <Button
                                                                type="submit"
                                                                variant="outline-success"
                                                                style={{
                                                                    backgroundColor: "#fff",
                                                                    color: "#008000",
                                                                    border: "1px solid #008000",
                                                                    borderRadius: "25px",
                                                                    padding: "20px 30px 20px 30px",
                                                                    fontSize: "16px",
                                                                    fontWeight: "bold",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    gap: "8px",
                                                                    transition: "background-color 0.3s ease, transform 0.3s ease", // Animation fluide
                                                                }}

                                                            >
                                                                <span className="text-dark">
                                                                    {(loadingCard || loadingReservation) ? (
                                                                        <>
                                                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> chargement...
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            {
                                                                                formData?.activateReservation && paymentMethod == "card" &&
                                                                                (<span> {`Confirmer paiement (${Number(Number(totalPrice * 0.13) / euroToDinar).toFixed(2)} ${currency.toUpperCase()} )`}</span>)
                                                                            }
                                                                            {
                                                                                formData?.activateReservation && paymentMethod == "bank" &&
                                                                                (<span> {`Confirmer`}</span>)
                                                                            }
                                                                            {
                                                                                formData?.activateReservation && paymentMethod == "cash" &&
                                                                                (<span> {`Confirmer`}</span>)
                                                                            }

                                                                            {
                                                                                formData?.activateReservation && paymentMethodR && !paymentMethod &&
                                                                                (<span> {`Confirmer`}</span>)
                                                                            }
                                                                            {
                                                                                !formData?.activateReservation && paymentMethodR &&
                                                                                (<span> {`Confirmer`}</span>)
                                                                            }
                                                                        </>
                                                                    )}
                                                                </span>
                                                                <span style={{ background: "white", borderRadius: "50%" }}>
                                                                    <FaArrowAltCircleRight color={"#43B613"} size={20} />
                                                                </span>
                                                            </Button>
                                                        </form>
                                                    )
                                                    : ""

                                    }
                                </div>
                            </div>
                        </Col>
                    </div>
                </div>

                <div style={{ position: "absolute", right: "1%", bottom: -30, zIndex: 60 }}>
                    <img src={Vector_Design} />
                </div>

            </div>









            {/* {
                currentItems && currentItems.length > 0 && (
                    <div className="container">
                        {
                            vehicleData && vehicleData?._id ?
                                (<h3 style={{ color: "#737373" }} className="py-2">Autres véhicules populaires</h3>)
                                :
                                propertyData && propertyData?._id ? (<h3 style={{ color: "#737373" }} className="py-2">Autres Prorpiétés populaires</h3>)
                                    : ""
                        }
                    </div>
                )
            }
            <div className="container">
                {currentItems.length > 0 && currentItems.filter((item) => item.isVisible == true).length > 0 && (
                    <Carousel responsive={responsive} autoPlay={true} infinite={true} transitionDuration={8}    >
                        {currentItems.length > 0 && currentItems.filter((item) => item.isVisible == true).length > 0 ? (
                            currentItems.filter((item) => item.isVisible == true).map((item) => {
                                // État unique pour chaque élément
                                const isHovered = hoverStates[item._id]; // Vérifie si l'élément actuel est survolé
                                return (
                                    <div
                                        onMouseEnter={() => handleMouseEnter(item._id)} // Déclenche lorsqu'on survole
                                        onMouseLeave={() => handleMouseLeave(item._id)} // Déclenche lorsque la souris quitte
                                        className="p-2"
                                    >
                                        <div className="" style={{ width: "100%" }}>
                                            <div className="shadow-sm rounded-lg" style={{ margin: "10px", width: "100%", overflow: "hidden", }}>

                                                <div style={{
                                                    height: "200px",
                                                    background: "#F2F2F2", width: "100%",
                                                    borderBottomLeftRadius: isHovered ? "20px" : "0px",
                                                    borderBottomRightRadius: isHovered ? "20px" : "0px",
                                                }}>
                                                    {
                                                        item && item.images && item.images.length > 0 ?
                                                            <img src={item.images[0]} style={{
                                                                height: "200px", width: "100%",
                                                                transition: "transform 0.3s ease-in-out",
                                                                transform: isHovered ? "scale(1.1)" : "scale(1)", // Zoom léger sur l'image
                                                            }} />
                                                            :
                                                            <img src={emptyImage} style={{
                                                                height: "200px", width: "100%",
                                                                transition: "transform 0.3s ease-in-out",
                                                                transform: isHovered ? "scale(1.1)" : "scale(1)", // Zoom léger sur l'image
                                                            }} />
                                                    }
                                                </div>
                                                <div style={{ background: "white", padding: "10px", borderBottomLeftRadius: "5px", borderBottomRightRadius: "5px" }}>
                                                    <div><h6 className="text-dark">{item.brand || item.name}</h6></div>
                                                    <div className="pt-2 pb-2" style={{ display: "flex", justifyContent: "space-between", }}>
                                                        <div>
                                                            <span style={{ fontWeight: "bold", fontSize: "25px" }} className="font-bold text-dark"> {item.basePricePerDay || 0} </span>
                                                            <span style={{ fontWeight: "bold", fontSize: "12px" }} className="text-dark">DZD</span>
                                                            <span style={{ color: "#A6A6A6", fontSize: "12px" }}>/Jour</span>
                                                        </div>
                                                        <div>
                                                        </div>
                                                    </div>
                                                    {// vehicle
                                                        item?.brand && (item?.mileage || item?.options?.automaticTransmission || item?.passenger || item?.engineType?.name) && (
                                                            <div style={{ padding: "5px 5px 5px 5px", display: "flex", justifyContent: "space-between", background: "#F6F6F6" }} className="my-3 rounded-lg">
                                                                {// kilometrage
                                                                    item?.mileage && (
                                                                        <div className="rounded-lg bg-grey p-2" style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
                                                                            <IoSpeedometerOutline className="text-dark" size={25} />
                                                                            <span className="text-dark">{item?.mileage || 0}</span>
                                                                        </div>
                                                                    )
                                                                }
                                                                {// transmition
                                                                    (item?.options?.automaticTransmission || item?.options?.manualTransmission) && (
                                                                        <div className="rounded-lg bg-grey p-2" style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
                                                                            <TbManualGearbox className="text-dark" size={25} />
                                                                            <span className="text-dark">
                                                                                {item?.options?.automaticTransmission ? "Auto" :
                                                                                    item?.options?.manualTransmission ? "Manuelle" : ""}
                                                                            </span>
                                                                        </div>
                                                                    )
                                                                }
                                                                {// Sièges
                                                                    item?.passenger && (
                                                                        <div className="rounded-lg bg-grey p-2" style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
                                                                            <MdOutlineAirlineSeatReclineNormal className="text-dark" size={25} />
                                                                            <span className="text-dark">{item?.passenger || 4}</span>
                                                                        </div>
                                                                    )
                                                                }

                                                                {//moteur
                                                                    item?.engineType && item?.engineType?.name && (
                                                                        <div className="rounded-lg bg-grey p-2" style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
                                                                            <FaChargingStation className="text-dark" size={25} />
                                                                            <span className="text-dark">{item?.engineType?.name || ""}</span>
                                                                        </div>
                                                                    )
                                                                }
                                                            </div>
                                                        )
                                                    }

                                                    {// property
                                                        item?.name && (
                                                            <div style={{ padding: "5px 5px 5px 5px", display: "flex", justifyContent: "space-between", background: "#F6F6F6" }} className="my-3 rounded-lg">

                                                                <div className="rounded-lg bg-grey p-2" style={{ display: "flex", justifyContent: "center", flexDirection: "row" }}>
                                                                    <MdOutlineLocationOn className="text-dark" size={25} />
                                                                    <span className="text-dark">{item.address}</span>
                                                                </div>
                                                            </div>
                                                        )
                                                    }

                                                    <div>
                                                        <Button type="button"
                                                            onClick={() => {
                                                                if (item?.color) {
                                                                    dispatch({ type: FETCH_VEHICLE_SUCCESS, payload: item });
                                                                    dispatch({ type: FETCH_PROPERTY_SUCCESS, payload: {} });
                                                                    navigate(`/${ROUTES.CAR_DETAIL_VIEW}/${item._id}/name/${item.brand}/description/${item.brand}`);
                                                                } else {
                                                                    dispatch({ type: FETCH_VEHICLE_SUCCESS, payload: {} });
                                                                    dispatch({ type: FETCH_PROPERTY_SUCCESS, payload: item });
                                                                    navigate(`/${ROUTES.CAR_DETAIL_VIEW}/${item._id}/name/${item.name}/description/${item.name}`);
                                                                }
                                                            }}
                                                            style={{
                                                                padding: "10px 5px 10px 5px", borderRadius: "30px", textAlign: "center", display: "flex", justifyContent: "center"
                                                                , borderRadius: "30px",
                                                                textAlign: "center",
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                transition: "all 0.3s ease-in-out", // Animation fluide
                                                            }}
                                                            variant={isHovered ? "dark" : "outline-dark"} // Change le variant du bouton
                                                            className={`w-100 ${isHovered ? "text-white" : "text-dark"} border-dark`}>
                                                            <div style={{ display: "flex", width: "100%", flexDirection: "row", justifyContent: isHovered ? "space-between" : "center", alignContent: "center" }}>

                                                                <div className={`${isHovered ? "px-3 font-fold" : "p-1"}`}>
                                                                    <span className="text-center "> Voire l{"'"}offre </span>
                                                                </div>
                                                                {
                                                                    isHovered && (
                                                                        <div className={`${isHovered ? "px-3 font-fold" : "p-1"}`} style={{ transition: "all 0.3s ease-in-out" }}>
                                                                            <FaArrowAltCircleRight size={25} className="text-primary" />
                                                                        </div>
                                                                    )
                                                                }

                                                            </div>
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        ) : (
                            <Col md={12}></Col>
                        )}
                    </Carousel>
                )}
            </div> */}






            {/* Modal de confirmation */}
            <Modal show={showModal} onHide={handleCloseModal} centered >
                <Modal.Header closeButton>
                    <Modal.Title>Confirmer la réservation</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    {/*style={{ backgroundColor: "#43B613" }} */}

                    {reservationElement == "Vehicle" ?
                        <p className="text-center">Êtes-vous sûr de vouloir confirmer la réservation du véhicule <strong>{vehicleData && vehicleData.brand ? vehicleData.brand : ""}</strong> </p>
                        : ""}
                    {reservationElement == "Property" ?
                        <p className="text-center">Êtes-vous sûr de vouloir confirmer la réservation de la propriété <strong> {propertyData && propertyData.name ? propertyData.name : ""}</strong> </p>
                        : ""}
                    <br />





                    {/*<strong>Montant total :</strong> {totalPrice.toLocaleString()} DZD */}



                    {/*Stripe */}


                    {/*
                        formData.activateReservation && (
                            <>
                                <h6 className="text-dark">Choix du paiement (Accompte) </h6>
                                <Row className="flex flex-row">
                                    <Col md={4} className="mb-2">
                                        <div
                                            className={`payment-option`}
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                flexDirection: "column",
                                                padding: "20px",
                                                borderRadius: "10px",
                                                cursor: "pointer",
                                                backgroundColor: paymentMethod === "card" ? "#55913d" : "#55913d",
                                                color: "#fff",
                                                border: paymentMethod === "card" ? "2px #fff solid" : "2px transparent solid"
                                            }}
                                            onClick={() => handlePaymentChoice("card")}
                                        >
                                            <FaCreditCard size={40} className={`payment-icon text-white`} />
                                            <span className={`text-white`}>Carte de Crédit</span>
                                        </div>
                                    </Col>

                                    <Col md={4} className="mb-2">
                                        <div
                                            className={`payment-option`}
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                flexDirection: "column",
                                                padding: "20px",
                                                borderRadius: "10px",
                                                cursor: "pointer",
                                                backgroundColor: paymentMethod === "bank" ? "#55913d" : "#55913d",
                                                color: "#fff",
                                                border: paymentMethod === "bank" ? "2px #fff solid" : "2px transparent solid"
                                            }}
                                            onClick={() => handlePaymentChoice("bank")}
                                        >
                                            <FaUniversity size={40} className={`payment-icon text-white`} />
                                            <span className={`text-white`}>Virement bancaire</span>
                                        </div>
                                    </Col>

                                    
                                </Row>
                                {
                                    paymentMethod === "card" && (
                                        <>
                                            <div className="col-md-12 form-group border" style={{ marginBottom: "15px", border: "0 0 1 0 2px solid" }}>
                                                <label htmlFor="customerName" style={{ fontWeight: "bold", marginBottom: "5px", display: "block" }}>Nom sur la carte</label>
                                                <input
                                                    className="form-control bg-white"
                                                    type="text"
                                                    id="customerName"
                                                    value={customerName}
                                                    onChange={(e) => setCustomerName(e.target.value)}
                                                    placeholder="Entrez le nom complet sur la carte ...."
                                                    required
                                                    style={{
                                                        fontSize: "16px",
                                                        width: "100%",
                                                        height: '40px',
                                                        background: "#FFFFFF",
                                                        borderRadius: "20px", // Bordures arrondies
                                                        border: "1px solid black", // Bordure légère pour améliorer la visibilité
                                                    }}
                                                />
                                            </div>

                                            <div className="col-md-12 form-group border" style={{ marginBottom: "15px", border: "0 0 1px 0 solid" }}>
                                                <label htmlFor="cardNumber" style={{ fontWeight: "bold", marginBottom: "5px", display: "block" }}>Numéro de carte</label>
                                                <CardNumberElement
                                                    style={{
                                                        fontSize: "16px",
                                                        width: "100%",
                                                        height: '40px',
                                                        background: "#FFFFFF",
                                                        borderRadius: "20px", // Bordures arrondies
                                                        border: "1px solid black", // Bordure légère pour améliorer la visibilité

                                                    }}
                                                />
                                            </div>

                                            <div className="col-md-12 form-group border" style={{ marginBottom: "15px", border: "0 0 1px 0 solid" }}>
                                                <label htmlFor="expiryDate" style={{ fontWeight: "bold", marginBottom: "5px", display: "block" }}>Date d’expiration</label>
                                                <CardExpiryElement
                                                    style={{
                                                        fontSize: "16px",
                                                        width: "100%",
                                                        height: '40px',
                                                        background: "#FFFFFF",
                                                        borderRadius: "20px", // Bordures arrondies
                                                        border: "1px solid black", // Bordure légère pour améliorer la visibilité

                                                    }}
                                                />
                                            </div>

                                            <div className="col-md-12 form-group border" style={{ marginBottom: "15px", border: "0 0 1px 0 solid" }}>
                                                <label htmlFor="cvc" style={{ fontWeight: "bold", marginBottom: "5px", display: "block" }}>CVC</label>
                                                <CardCvcElement
                                                    style={{

                                                        fontSize: "16px",
                                                        width: "100%",
                                                        height: '40px',
                                                        background: "#FFFFFF",
                                                        borderRadius: "20px", // Bordures arrondies
                                                        border: "1px solid black", // Bordure légère pour améliorer la visibilité

                                                    }}
                                                />
                                            </div>





                                            {errorStripe && <p style={{ color: 'red', marginTop: "10px" }}>{errorStripe}</p>}
                                            {success && <p style={{ color: 'green', marginTop: "10px" }}>Paiement réussi ! Merci, {customerName}.</p>}
                                        </>
                                    )
                                        
                                }

                                {paymentMethod === "bank" && (
                                    <>
                                        <Form.Group>
                                            <Form.Label>Numéro de compte</Form.Label>
                                            <Form.Control style={{
                                                height: '40px',
                                                background: "#FFFFFF",
                                                borderRadius: "20px", // Bordures arrondies
                                                border: "1px solid black", // Bordure légère pour améliorer la visibilité
                                            }} type="text" name="accountNumber" value={bankInfo.accountNumber} placeholder="Numéro de compte" />
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label>Nom de la banque</Form.Label>
                                            <Form.Control style={{
                                                height: '40px',
                                                background: "#FFFFFF",
                                                borderRadius: "20px", // Bordures arrondies
                                                border: "1px solid black", // Bordure légère pour améliorer la visibilité
                                            }} type="text" name="bankName" value={bankInfo.bankName} placeholder="Nom de la banque" />
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label>IBAN</Form.Label>
                                            <Form.Control style={{
                                                height: '40px',
                                                background: "#FFFFFF",
                                                borderRadius: "20px", // Bordures arrondies
                                                border: "1px solid black", // Bordure légère pour améliorer la visibilité
                                            }} type="text" name="iban" value={bankInfo.iban} placeholder="IBAN" />
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label>BIC/SWIFT</Form.Label>
                                            <Form.Control style={{
                                                height: '40px',
                                                background: "#FFFFFF",
                                                borderRadius: "20px", // Bordures arrondies
                                                border: "1px solid black", // Bordure légère pour améliorer la visibilité
                                            }} type="text" name="swiftCode" value={bankInfo.swiftCode} placeholder="BIC/SWIFT" />
                                        </Form.Group>
                                    </>
                                )
                            </>
                        )</Container>
                    */}

                    <Form>

                        <Form.Group className="mb-3">
                            <Form.Label className="text-white">Code Promo</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Entrez un code promo"
                                className="border border-dark"
                                value={promoCode}
                                style={{
                                    height: '40px',
                                    background: "#FFFFFF",
                                    borderRadius: "20px", // Bordures arrondies
                                    border: "1px solid black", // Bordure légère pour améliorer la visibilité
                                }}
                                onChange={(e) => {
                                    const inputValue = e.target.value; // Récupérer la valeur saisie
                                    if (inputValue.length <= 30) {
                                        setPromoCode(inputValue); // Mettre à jour la valeur si elle ne dépasse pas 30 caractères
                                    }
                                }}
                            />
                        </Form.Group>
                    </Form>

                    {
                        //information dur le moyment d epaiement de la réservation
                        <PaymentReservationConfirmationMessage paymentMethodR={paymentMethodR} />
                    }
                </Modal.Body>
                <Modal.Footer>
                    <form onSubmit={handleSubmit}>
                        <Button type='button' variant="light" className="rounded-pill" onClick={handleCloseModal}>
                            Annuler
                        </Button>

                        <Button
                            type={loadingCard ? "button" : "subumit"}
                            variant="primary"
                            style={{ textAlign: "center" }}
                            className="rounded-pill"
                            disabled={!stripe}
                        >



                            {(loadingCard || loadingReservation) ? (
                                <>
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> chargement...
                                </>
                            ) : (
                                <>
                                    {
                                        formData?.activateReservation && paymentMethod == "card" &&
                                        (<span> {`Confirmer paiement (${Number(Number(totalPrice * 0.13) / euroToDinar).toFixed(2)} ${currency.toUpperCase()} )`}</span>)
                                    }
                                    {
                                        formData?.activateReservation && paymentMethod == "bank" &&
                                        (<span> {`Confirmer`}</span>)
                                    }
                                    {
                                        formData?.activateReservation && paymentMethod == "cash" &&
                                        (<span> {`Confirmer`}</span>)
                                    }

                                    {
                                        formData?.activateReservation && paymentMethodR && !paymentMethod &&
                                        (<span> {`Confirmer`}</span>)
                                    }
                                    {
                                        !formData?.activateReservation && paymentMethodR &&
                                        (<span> {`Confirmer`}</span>)
                                    }
                                </>
                            )}

                        </Button>
                    </form>
                </Modal.Footer>
            </Modal>
        </Container>
    );
};

export default InvoiceReservationWebPage;
